import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import Cookies from "js-cookie";
import Modal from "react-modal";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "./config/aws.exports";
Amplify.configure(awsconfig);

import axios from "./axios/axios";
import AuthenticatedRoutes from "./routes/AuthenticatedRoutes";
import UnauthenticatedRoutes from "./routes/UnauthenticatedRoutes";
import AuthContext from "./contexts/AuthContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "tippy.js/dist/tippy.css";

import KonfhubLoad from "./components/KonfhubLoad";
import { sortEventDetails } from "./Utils/helpers";
import { getOrganiserEventsDetails } from "./revampCRUD/app.crud";
import { errorToaster } from "./reusable/common";

import TagManager from "react-gtm-module";
import ImageUploadContext from "./contexts/ImageUploadContext";
import ImageUploadingModal from "./revampComponents/Atom/Modals/ImageUploadingModal";
import VerifyAadhaar from "./revampPages/AadharVerificationRedirect/index";

const tagManagerArgs = { gtmId: "GTM-KHHN35F" };
TagManager.initialize(tagManagerArgs);
Modal.setAppElement("#root");

const Page404 = React.lazy(() => import("./pages/Page404"));

class App extends Component {
	state = {
		user: { attributes: {} },
		signedIn: null,
		organiserDetails: null,
		communityDetails: null,
		eventInfo: {},
		showUploadImageModal: false,
		selectedFiles: [],
		uploadProgress: {},
		failedFile: []
	};

	componentDidMount() {
		this.checkSession();
	}

	// 🔥 NEW — SUPER CLEAN
	checkSession = async () => {
		try {
			const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
			Cookies.set("userEmail", user.attributes.email);
			localStorage.setItem("eventId", user.attributes["custom:lastEvent"]);

			const organiserDetails = await this.getOrganiserDetails();

			this.setState({
				user,
				signedIn: true,
				organiserDetails,
				communityDetails: null
			});
		} catch (err) {
			console.warn("No authenticated user", err);
			this.setState({ signedIn: false });
		}
	};

	// unchanged logic, but no token logic needed anymore
	getOrganiserDetails = async () => {
		try {
			const orgRes = await getOrganiserEventsDetails();
			if (orgRes.status === 200) {
				return sortEventDetails(orgRes.data || []);
			} else if (orgRes.status === 404) {
				errorToaster("There is no user with this Id, please log in again");
				this.setAuth({}, false);
			}
		} catch (err) {
			console.error(err);
			errorToaster("Something went wrong, please try again later");
		}
		return [];
	};

	setAuth = async (user = {}, signedIn = true) => {
		this.setState({ user, signedIn });

		if (signedIn) {
			const organiserDetails = await this.getOrganiserDetails();
			this.setState({ organiserDetails });
		}
	};

	refreshOrganiserDetails = async () => {
		const organiserDetails = await this.getOrganiserDetails();
		this.setState({ organiserDetails });
	};

	setCommunityDetails = (communityDetails = null) => {
		this.setState({ communityDetails });
	};

	setEventDetails = async eventInfo => {
		this.setState({ eventInfo });
	};

	storeGalleryDetails = selectedFiles => {
		this.setState({ showUploadImageModal: true, selectedFiles });
	};

	setUploadProgress = uploadProgress => {
		this.setState(prevState => ({
			uploadProgress: { ...prevState.uploadProgress, ...uploadProgress }
		}));
	};

	clearGalleryDetails = () => {
		this.setState({
			showUploadImageModal: false,
			selectedFiles: [],
			failedFile: [],
			uploadProgress: {}
		});
	};

	storeFailedUpload = fileName => {
		this.setState(prevState => ({
			showUploadImageModal: true,
			failedFile: [...(prevState.failedFile || []), fileName]
		}));
	};

	render() {
		const {
			user,
			signedIn,
			organiserDetails,
			communityDetails,
			eventInfo,
			showUploadImageModal,
			selectedFiles,
			uploadProgress,
			failedFile
		} = this.state;

		return (
			<>
				<div className="content-container h-100 d-flex flex-column">
					<AuthContext.Provider
						value={{
							user,
							signedIn,
							setAuth: this.setAuth,
							eventInfo,
							setEventDetails: this.setEventDetails,
							organiserDetails,
							communityDetails,
							refreshOrganiserDetails: this.refreshOrganiserDetails,
							setCommunityDetails: this.setCommunityDetails
						}}
					>
						<ImageUploadContext.Provider
							value={{
								storeGalleryDetails: this.storeGalleryDetails,
								clearGalleryDetails: this.clearGalleryDetails,
								setUploadProgress: this.setUploadProgress,
								storeFailedUpload: this.storeFailedUpload
							}}
						>
							<ImageUploadingModal
								selectedFiles={selectedFiles}
								showUploadImageModal={showUploadImageModal}
								uploadProgress={uploadProgress}
								failedFile={failedFile}
								clearGalleryDetails={this.clearGalleryDetails}
							/>

							<BrowserRouter>
								<LastLocationProvider>
									<React.Suspense fallback={<KonfhubLoad />}>
										<Switch>
											<Route
												exact
												path="/404"
												name="Page 404"
												render={props => <Page404 {...props} />}
											/>
											<Route
												exact
												path="/verify-aadhaar"
												name="Aadhaar KYC Verification"
												render={props => <VerifyAadhaar {...props} />}
											/>
											{signedIn === null ? (
												<KonfhubLoad />
											) : signedIn ? (
												<AuthenticatedRoutes signedIn={signedIn} user={user} />
											) : (
												<UnauthenticatedRoutes signedIn={signedIn} user={user} />
											)}
										</Switch>
									</React.Suspense>
								</LastLocationProvider>
							</BrowserRouter>
						</ImageUploadContext.Provider>
					</AuthContext.Provider>
				</div>
				<style>{`
          			.content-container {
            			background-color: ${localStorage.getItem("darkMode") ? "#2f2f2f" : "auto"};
          			}
        		`}</style>
			</>
		);
	}
}

export default App;
